var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"service":"Sectors","messages":_vm.messages,"headers":_vm.headers,"mypopup":_vm.mypopup,"show-actions":""},scopedSlots:_vm._u([{key:"form",fn:function({ value, listeners }){return [_c('Sector',_vm._g({staticClass:"pa-4",attrs:{"value":value}},listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }